import React from "react";
import Clickable from "shared/components/oknf/_Clickable";

const OkCheckbox = (props) => (
	<Clickable {...props} type="checkbox" />
);

export default OkCheckbox;



// WEBPACK FOOTER //
// ./src/shared/components/oknf/OkCheckbox.jsx